import {
  UPDATE_PVS_CATEGORY_REQUEST,
  UPDATE_PVS_CATEGORY_SUCCESS,
  UPDATE_PVS_CATEGORY_FAILURE,
  RESET_PVS_CATEGORY_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const updatePvsCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PVS_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case UPDATE_PVS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Category updated successfully",
      };

    case UPDATE_PVS_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to update category",
      };

    case RESET_PVS_CATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default updatePvsCategoryReducer;
